import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import GeneralEventName from 'lumen/components/general/event-name';
import type { Event } from 'lumen/models';

interface HotelMarketInsightListsListItemsListItemEventSignature {
  Args: {
    event: Event;
  };
}

const HotelMarketInsightListsListItemsListItemEvent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <span class="mr-200">
    <PrismIcon @name={{@event.icon}} @size="small" />
  </span>
  <div class="flex flex-col">
    <GeneralEventName @event={{@event}} class="text-300--bold" />
    <div class="event-info mt-200 flex flex-row">
      <span class="mr-100">
        <PrismIcon @name="calendar-accepted" @size="small" />
      </span>
      <p class="text-300--regular">{{@event.formattedDays}}</p>
    </div>
    {{#if @event.location}}
      <div class="event-info mt-200 flex flex-row items-center">
        <span class="mr-100">
          <PrismIcon @name="location-pin" @size="small" />
        </span>
        <p class="text-300--regular">{{@event.location}}</p>
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<HotelMarketInsightListsListItemsListItemEventSignature>;

export default HotelMarketInsightListsListItemsListItemEvent;
